import type { SelectOption } from '@property.com.au/ui-kit';
import { PropertyConfig } from '../reducers/propertyConfigReducer';
import { isPropertyStatusForRent } from './isPropertyStatusForRent';
import { SEARCH_EXCLUDE_DEPOSIT_TAKEN_DEFAULT } from './defaults';

export const getExcludeDepositTakenOnPropertyStatusChange = (
  { propertyStatus: currentPropertyStatus, excludeDepositTaken }: PropertyConfig,
  newPropertyStatus: SelectOption,
): boolean => {
  if (
    isPropertyStatusForRent(currentPropertyStatus?.value) &&
    !isPropertyStatusForRent(newPropertyStatus.value)
  ) {
    // Set exclude deposit taken to default because property status' other than FOR_RENT have no exclude deposit taken option
    return SEARCH_EXCLUDE_DEPOSIT_TAKEN_DEFAULT === 'true';
  }
  return excludeDepositTaken;
};
